var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "700",
      "color": "black"
    }
  }, [_vm._v("合同信息")]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px",
      "font-size": "15px",
      "font-weight": "700"
    }
  }, [_vm._v("组织架构：" + _vm._s(_vm.$globals.group_name + '/' + _vm.$parent.$parent.ruleForm.range))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "font-size": "15px",
      "font-weight": "700"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "column",
      "width": "50%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_vm._v("身份证：" + _vm._s(_vm.$parent.$parent.ruleForm.staff_card))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_vm._v("\n\t\t\t\t\t起止时间：" + _vm._s(_vm.$parent.$parent.ruleForm.start_date) + "-" + _vm._s(_vm.$parent.$parent.ruleForm.end_date))])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.$parent.$parent.ruleForm.staff_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_vm._v("手机号：" + _vm._s(_vm.$parent.$parent.ruleForm.staff_telephone))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_vm._v("岗位：" + _vm._s(_vm.$parent.$parent.ruleForm.post_name))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "700",
      "margin-top": "20px"
    }
  }, [_vm._v("附件：" + _vm._s(_vm.$parent.$parent.ruleForm.staff_card))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "700",
      "color": "black",
      "margin-top": "80px"
    }
  }, [_vm._v("合同签订信息")]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "700"
    }
  }, [_vm._v("合同订单附件：")]), _vm._v(" "), _c('div', [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.action,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.uploadFujian,
      "before-remove": _vm.beforeRemove,
      "multiple": "",
      "on-exceed": _vm.c,
      "file-list": _vm.fileList
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px",
      "height": "25px"
    },
    attrs: {
      "src": require("../../../assets/上传附件.png")
    }
  })])], 1)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px 0 0 220px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.saveFj
    }
  }, [_vm._v("保存")])], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27832e52","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtQd/Htqd_qian.vue
// module id = null
// module chunks = 